import { render, staticRenderFns } from "./CardsSectionNewCopy.vue?vue&type=template&id=3dd900a1&scoped=true&"
import script from "./CardsSectionNewCopy.vue?vue&type=script&lang=js&"
export * from "./CardsSectionNewCopy.vue?vue&type=script&lang=js&"
import style0 from "./CardsSectionNewCopy.vue?vue&type=style&index=0&id=3dd900a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd900a1",
  null
  
)

export default component.exports